
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from "react";
import { faAddressBook, faIdCard, faPhone, faFile, faBuilding, faUser, faMapMarker } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Card, Button, Badge, Container, InputGroup } from '@themesberg/react-bootstrap';

import api from "../../api/axios";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useHistory } from "react-router-dom";
import { addMember, dashboardUserFiles,getPincodeDetails } from "../../api/services";
import Preloader from "../../components/Preloader"; // Path to your code above
// import { useHistory } from "react-router-dom";
import { faHips } from "@fortawesome/free-brands-svg-icons";
import { Routes } from "../../routes";

export default () => {
  const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
  const [showLoader, setShowLoader] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [routeName, setRouteName] = useState("");
  const [address, setAddress] = useState("");
  const [addressType, setAddressType] = useState(""); // Hub / Customer
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [stateName, setStateName] = useState("");
  const [country, setCountry] = useState("");
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setShowLoader(true);
    setSuccess("");
    setError("");

    try {
      const payload = {
        routeName: routeName,
        addressType: addressType,
        pincode: pincode,
        city: city,
        stateName: stateName,
        country: country
      };

      const resp = await addMember(payload);

      const uploadResp = await dashboardUserFiles(null, 103);
      console.log("File upload response:", uploadResp);
      setShowLoader(true);
      console.log("Profile update response:", resp);
      setSuccess("Address added successfully!");
      await delay(5000); // Waits for 2 seconds
      history.push(Routes.Team_Driver.path);
    } catch (error) {
      console.log("Form submission error:", error.response?.data || error.message);
      setShowLoader(false);
      // ✅ Better error handling
      setError(
        error.response.data.error || "Something went wrong!"
      );
    } finally {
      setShowLoader(false);
    }
  };

  const fetchLocationByPincode = async (pin) => {
    if (pin.length !== 6) return;
    console.log("Fetching location for pincode:", pin);
    try {
      const data = await getPincodeDetails(pin);

      console.log("Pincode API response:", data);
      if (data[0].Status === "Success") {
        const postOffices = data[0].PostOffice;
        
        const deliveryOffice =
        postOffices.find(po => po.DeliveryStatus === "Delivery") ||
        postOffices[0];


        setCity(deliveryOffice.Block || deliveryOffice.District);
      setStateName(deliveryOffice.State);
      setCountry(deliveryOffice.Country);
      } else {
        setError("Invalid Pincode");
      }
    } catch (err) {
      console.error(err);
      setError("Failed to fetch location");
    }
  };

  return (
    <main>
      <Preloader show={showLoader} />

      <Container className="px-0" style={{ backgroundColor: `#ffffff` }}>
        <section className="d-flex align-items-center my-5 mt-lg-2 mb-lg-2" >
          <Container>
            {error && (<div class="alert alert-danger">
              {error}
            </div>)}

            {
              success && (<div class="alert alert-success">
                {success}
              </div>)
            }
            <Row className="justify-content-center form-bg-image">
              <Col lg={12} /*className="d-flex align-items-center justify-content-center"*/>
                <Form className="mt-0" onSubmit={handleSubmit}>
                  <Form.Group id="first-name" className="mb-2">
                    <Form.Label>Identification Name</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUser} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="tel"
                        placeholder="Name"
                        value={routeName}
                        onChange={(e) => setRouteName(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group id="address" className="mb-2">
                    <Form.Label>Identification Name</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUser} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="tel"
                        placeholder="Address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Address Type</Form.Label>
                    <Form.Select
                      required
                      value={addressType}
                      onChange={(e) => setAddressType(e.target.value)}
                    >
                      <option value="">Select Type</option>
                      <option value="HUB">Hub</option>
                      <option value="CUSTOMER">Customer</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Pincode</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      maxLength={6}
                      placeholder="Pincode"
                      value={pincode}
                      onChange={(e) => {
                        const value = e.target.value;

                        // allow only digits
                        if (/^\d*$/.test(value)) {
                          setPincode(value);

                          // auto fetch when 6 digits entered
                          if (value.length === 6) {
                            fetchLocationByPincode(value);
                          }
                        }
                      }}
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-2">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="City"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>State</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="State"
                      value={stateName}
                      onChange={(e) => setStateName(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Country"
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                    />
                  </Form.Group>
                                    
                  <Button variant="primary" type="submit" className="w-100">
                    Add Address
                  </Button>
                </Form>
                <div className="d-flex justify-content-center align-items-center mt-4">
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Container>
    </main>
  );
};
